import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { getHttpHeader } from './../../../utils/http-header.factory';
import { BaseService } from '../../../templates/services/base-service.template';
import { Core2Config } from './../../../utils/core2-config';
import { ApiResponseModel } from './../../../models/base/api-response.model';
import { ApiVisa } from './../../../models/base/apivisa.model';

@Injectable({
  providedIn: 'root'
})
export class PermissionSetService implements BaseService {

  public readonly apiUrl: string = Core2Config.TENANT_CUSTOM_URL_PREFIX + Core2Config.UNIPIN_PREFIX + 'shared/get-perm-set-hdr-guid';

  constructor(protected readonly http: HttpClient) {}

  public getAssigned(assigneeGuid: string, appletGuid: string, keyword: string, { api_domain_url, jwt_secret, tenantCode }: ApiVisa): Observable<ApiResponseModel<string[]>>{
    return this.http.get<ApiResponseModel<string[]>>(`${ api_domain_url }${ this.apiUrl }?assignee_hdr_guid=${ assigneeGuid }&applet_guid=${ appletGuid }${ keyword? `&keyword=${ keyword }` : '' }`, getHttpHeader(jwt_secret, tenantCode));
  }
}
